import React, { useState, useEffect } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { useNavigate } from "react-router-dom";
import { LayoutData } from "../Structur/Aconlayout";

export const PdfViewer = ({ PdfDocument }) => {
  const { aktPdfDaten } = LayoutData();
  const navigate = useNavigate();

  useEffect(() => {
    if (!aktPdfDaten) navigate("/");
  }, [aktPdfDaten]);
 
  return (
    <>
      <div className="page-pdf">
        <PDFViewer width="100%" height="100%">
          {aktPdfDaten}
        </PDFViewer>
      </div>
    </>
  );
};
